<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="类别" prop="typeId">
              <!-- <el-input v-model="searchForm.typeId" auto-complete="off"></el-input> -->
              <el-cascader
                style="width:100%"
                clearable
                v-model="typeId"
                :show-all-levels="false"
                :props="typeTreeProps"
                placeholder="请选择所属类别"
                :options="typeTreeList"
                @change="typeSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="视频名称" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入名称" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="时间">
              <el-date-picker
                style="width:100%"
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="timeChange"
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6" style="float:right">
            <!-- <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>-->
            <!-- <el-button type="primary" @click="importExce" >下载模板</el-button> -->
            <el-button-group style="float:right">
              <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
              <el-button
                type="danger"
                @click="batchDeleteTencentVideoInfo"
                icon="el-icon-minus"
              >批量删除</el-button>
              <!-- <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">批量导入</el-button> -->
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12"></el-col>
        <el-col style="text-align: right" :span="24">
          <el-button type="primary" @click="importExcel" icon="el-icon-download">下载模板</el-button>
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <!-- <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button> -->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="size" label="视频大小"></el-table-column>
        <el-table-column prop="duration" label="时长（秒）"></el-table-column>
        <el-table-column prop="playCount" label="播放次数"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>-->
              <i
                class="iconfont iconshanchu mainColor"
                title="删除"
                @click="deleteTencentVideoInfo(scope.row)"
              ></i>
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteTencentVideoInfo(scope.row)">删除</span>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="excelFullTypeName" label="类别" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="size" label="视频大小"></el-table-column>
        <el-table-column prop="duration" label="时长（秒）"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
        <el-table-column prop="excelDataState" label="是否通过"></el-table-column>
        <el-table-column prop="excelDataFailReason" label="原因" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createTime: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      typeTreeList: [],
      typeTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      importFormVisible: false,
      typeId: [],
      searchForm: {
        typeId: "",
        name: "",
        tencentVideoId: ""
      },
      addForm: {},
      addFormRules: {},
      editForm: {},
      editFormRules: {},
      importForm: [],
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/tencentVideoInfo/importExcelCheck`,
      fileList: [],
      loading: true
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getTencentVideoInfo() {
      this.api.tencentVideoInfo
        .getTencentVideoInfo({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    typeSearchChange() {
      if (this.typeId.length > 0) {
        this.searchForm.typeId = this.typeId[2];
      } else {
        this.searchForm.typeId = "";
      }
      console.log("this.searchForm.typeId", this.searchForm.typeId);
    },
    timeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.tencentVideoInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importExcel() {
      window.open(
        "https://ztiku.oss-cn-hangzhou.aliyuncs.com/%E8%A7%86%E9%A2%91%E6%A8%A1%E6%9D%BF.xlsx"
      );
    },
    addTencentVideoInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.tencentVideoInfo
            .addTencentVideoInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateTencentVideoInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.tencentVideoInfo
            .updateTencentVideoInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteTencentVideoInfo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.tencentVideoInfo
            .deleteTencentVideoInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteTencentVideoInfo() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.tencentVideoInfo
            .deleteTencentVideoInfo(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.typeId = "";
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.typeId = [];
      this.createTime = [];
      this.pageList();
    },
    getTencentVideoTypeTree() {
      this.api.tencentVideoInfo.getTencentVideoTypeTree().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  delete itemss.children;
                }
              } else {
                // delete items.children;
              }
            }
          } else {
            // delete item.children;
          }
        }
        this.typeTreeList = result.data;
      });
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.tencentVideoInfo
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.tencentVideoInfo
        .importData(this.importForm)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    // 'addFormVisible': function (newVal) {
    //   if (!newVal) {
    //     this.$refs.addForm.resetFields();
    //     this.pageList()
    //   } else {
    //   }
    // },
    // 'editFormVisible': function (newVal) {
    //   if (!newVal) {
    //     this.$refs.editForm.resetFields();
    //     this.pageList()
    //   } else {
    //     this.getTencentVideoInfo()
    //   }
    // }
  },
  mounted() {
    this.pageList();
    this.getTencentVideoTypeTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/tencentVideoInfo/index.vue